import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import * as images from "../../constants/Images";
import PropTypes from "prop-types";
import LogoutDialogueBox from "../../ReusableComponents/DeleteDialogueBox/LogoutDialogueBox";
import "./Sidebar.css";
import LogoutService from "../../services/LogoutService";
import Loadspinner from "../Loadspinner";
import Avatar from "react-avatar";
import CommonService, { downloadBlob } from "../../services/CommonService";
import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";
import CircleIcon from "@mui/icons-material/Circle";
import LinkIcon from "@mui/icons-material/Link";
import FlakyIcon from "@mui/icons-material/Flaky";
import { decryptV2 } from "../../helpers/Cryptography/CryptoV2";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function Sidebar(props) {
  const [isAdmin, setIsAdmin] = useState(
    decryptV2(getFromEncLocalStorage("ggwp") || "")
  );

  const { activeLink } = props;
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [showModal, setModal] = useState(false);
  const [dp, setdp] = useState("");
  const [badge, setBadge] = useState("");
  const [badgeImg, setBagdePic] = useState("");
  const [points, setPoints] = useState();
  const [empName, setName] = useState("");
  const [position, setposition] = useState("");
  const [showDashboard, setDashboard] = useState(false);
  const [showApplications, setShowApplications] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showMasters, setMasters] = useState(
    activeLink?.toLowerCase()?.includes("master")
  );

  const [ck, setCk] = useState(getFromEncLocalStorage("CK"));
  const [portalUrlKMI, setPortalUrlKMI] = useState("");
  const [portalUrlSFQUERY, setPortalUrlSFQUERY] = useState("");
  const [portalUrlTPP, setPortalUrlTPP] = useState("");
  // const configSet = useSelector((state) => state.configSet);
  const applicationsUrl = getFromEncLocalStorage("ApplicationsUrl")
    ? JSON.parse(getFromEncLocalStorage("ApplicationsUrl"))
    : [];

  useEffect(() => {
    getDetails();
    getProfile().finally(() => {
      setLoading(false);
    });
    setCk(getFromEncLocalStorage("CK"));
  }, []);

  // useEffect(() => {
  //   if (configSet) {
  // setPortalUrlKMI(getFromEncLocalStorage("PortalUrlKMI") || "");
  // setPortalUrlSFQUERY(getFromEncLocalStorage("PortalUrlSFQUERY") || "");
  // setPortalUrlTPP(getFromEncLocalStorage("PortalUrlTPP") || "");
  //   }
  // }, [configSet]);

  const getDetails = async () => {
    let dp = await getFromEncLocalStorage("profile_pic");
    let firstName = await getFromEncLocalStorage("firstname");
    let lastName = await getFromEncLocalStorage("lastname");
    let position = await getFromEncLocalStorage("nameofposition");
    let name = firstName + " " + lastName;

    setdp(dp);
    setName(name);
    setposition(position);
  };

  const getProfile = async () => {
    setLoading(true);
    try {
      //console.log('Sidebar.js getProfileDetails Started');
      const res = await CommonService.getProfileDetails();
      //console.log('Sidebar.js getProfileDetails response recieved');
      if (res) {
        //console.log('Sidebar.js getProfileDetails if (res)');
        setPoints(res.points);
        //console.log('Sidebar.js getProfileDetails setPoints');
        if (res?.badgeDetails?.badges) setBadge(res.badgeDetails.badges);
        //console.log('Sidebar.js getProfileDetails setBadge');
        if (res?.badgeDetails?.badge_picture) {
          let reqImage = await downloadBlob(res?.badgeDetails?.badge_picture);
          //console.log('Sidebar.js getProfileDetails downloadBlob');
          // // if (res.points >= 0 && res.points <= 1000) {
          // //   reqImage = images.badge1;
          // // } else if (res.points > 1000 && res.points <= 10000) {
          // //   reqImage = images.badge2;
          // // } else if (res.points > 10000 && res.points <= 50000) {
          // //   reqImage = images.badge3;
          // // } else if (res.points > 50000 && res.points <= 100000) {
          // //   reqImage = images.badge4;
          // // } else if (res.points > 100000 && res.points <= 500000) {
          // //   reqImage = images.badge5;
          // // }
          setBagdePic(reqImage);
        }
        //setLoading(false);
        //console.log('Sidebar.js getProfileDetails setBagdePic');
      }
    } catch (err) {
      console.error("Sidebar.js error : ", err);
    } finally {
      //console.log('Sidebar.js finally setLoading : ', isLoading);
      setLoading(false);
    }
    //console.log('Sidebar.js getProfileDetails end');
    //setLoading(false);
  };

  const logout = async () => {
    setLoading(true);
    const res = await LogoutService.logout();
    console.log(res);
    //logEvent(analytics(), "logout");
    setLoading(false);
    localStorage.clear();
    RedirectToLogout();
    //history.push("/");
  };

  const RedirectToLogout = () => {
    window.location.href =
      "https://login.microsoftonline.com/common/oauth2/logout";
  };

  if (!props.renderAgain) {
    return null;
  }

  const MasterLinks = () => {
    const masters = [
      {
        title: "Aggregate",
        link: "/aggregate-master",
        sysname: "aggregate_master",
      },
      { title: "Hashtag", link: "/hashtag-master", sysname: "hashtag_master" },
      {
        title: "Platform",
        link: "/platform-master",
        sysname: "platform_master",
      },
      {
        title: "Event Gallery",
        link: "/event-gallery-master",
        sysname: "event_gallery_master",
      },
      { title: "Badge", link: "/badge-master", sysname: "badge_master" },
      {
        title: "User Role",
        link: "/userrole-master",
        sysname: "userrole_master",
      },
      {
        title: "App Version",
        link: "/appversion-master",
        sysname: "appversion_master",
      },
      {
        title: "Ticker Data",
        link: "/ticker-master",
        sysname: "ticker_master",
      },
      {
        title: "Useful Links",
        link: "/usefullink-master",
        sysname: "usefullink_master",
      },
      {
        title: "Guidelines",
        link: "/guidelines-master",
        sysname: "guidelines_master",
      },
      {
        title: "Calendar Event",
        link: "/calendarEvent-master",
        sysname: "calendarEvent_master",
      },
      {
        title: "Knowledge Base",
        link: "/knowledgebase-master",
        sysname: "knowledgebase_master",
      },
    ].sort((a, b) => a.title.localeCompare(b.title));
    return (
      <div>
        <ul className="list-group">
          <li className=" d-flex justify-content-between align-items-start">
            <div className="me-auto">
              {masters.map((masterItem, masterIndex) => {
                const { title, link, sysname } = masterItem;
                return (
                  <Link
                    key={title}
                    to={link}
                    id={activeLink == sysname ? "sidebar-active-item" : null}
                    className="sidebar-submenuitem"
                    style={{ paddingLeft: "50px" }}
                  >
                    <CircleIcon className="sidebar-sub-menu-icon" />
                    <span style={{ marginTop: "5px" }}>{title}</span>
                  </Link>
                );
              })}
            </div>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <nav className="side-bar">
      <Loadspinner
        filename="Sidebar.js"
        isLoading={isLoading}
        isMiddle="false"
      />
      {dp ? (
        <img src={dp} alt="Profile pic" className="profile-img" />
      ) : (
        <Avatar
          name={empName}
          size="50px"
          round={true}
          style={{ marginTop: "10px" }}
        />
      )}
      <h6 style={{ marginBottom: "5px " }}>{empName}</h6>
      <p style={{ fontSize: "11px" }}>{position}</p>
      <Link to="/profile">
        <button className="profile-button">Profile</button>
      </Link>
      <div className="row sidebar-badge">
        <div className="verticalLine"></div>
        <h5
          className="col-2"
          style={{ margin: "auto", paddingRight: "0", marginLeft: "0px" }}
        >
          {points}
        </h5>
        <p className="col-3" style={{ paddingLeft: "10px" }}>
          Total points
        </p>
        <img className="col-1 sidebar-badge-img" src={badgeImg} />
        <p className="col-3" style={{ marginRight: "15px", paddingLeft: "0" }}>
          {badge}
        </p>
        <h4 className="col-3"></h4>
      </div>
      <div className="sidebar-menu">
        <div style={{ marginBottom: "5rem" }}>
          <>
            {isAdmin === "true" && (
              <>
                <div
                  onClick={() => setMasters(!showMasters)}
                  style={{ cursor: "pointer" }}
                  className="sidebar-menuitem"
                >
                  <img
                    src={images.usefullinks_sb}
                    className="menu-img"
                    alt="Masters"
                  />
                  <span style={{ marginTop: "5px" }}>Master</span>
                  <img src={images.down_arrow} className="toggle-dashboard" />
                </div>
                {showMasters ? <MasterLinks /> : null}
              </>
            )}
          </>

          {/* <Link
          to="/questions-answered-by-me"
          id={activeLink == "que_ans_by_me" ? "sidebar-active-item" : null}
          className="sidebar-menuitem"
        >
          <img
            src={images.sb1}
            className="menu-img"
            alt="Questions answered by me"
          />
          <span style={{ marginTop: "5px" }}>Questions answered by me</span>
        </Link>
        <Link
          to="/questions-asked-by-me"
          id={activeLink == "que_by_me" ? "sidebar-active-item" : null}
          className="sidebar-menuitem"
        >
          <img
            src={images.sb1}
            className="menu-img"
            alt="Questions asked by me"
          />
          <span style={{ marginTop: "5px" }}>Questions asked by me</span>
        </Link>
        <Link
          to="/knowledge-created-by-me"
          id={activeLink == "knowledge_by_me" ? "sidebar-active-item" : null}
          className="sidebar-menuitem"
        >
          <img
            src={images.sb2}
            className="menu-img"
            alt="Knowledge created by me"
          />
          <span style={{ marginTop: "5px" }}>Knowledge created by me</span>
        </Link> */}

          <div
            onClick={() => setDashboard(!showDashboard)}
            style={{ cursor: "pointer" }}
            className="sidebar-menuitem"
          >
            <img
              src={images.dashboard_sb}
              className="menu-img"
              alt="Questions asked by me"
            />
            <span style={{ marginTop: "5px" }}>Dashboard</span>
            <img src={images.down_arrow} className="toggle-dashboard" />
          </div>
          {showDashboard ||
          activeLink == "dashboard" ||
          activeLink == "que_by_me" ||
          activeLink == "que_ans_by_me" ||
          activeLink == "knowledge_by_me" ||
          activeLink == "questions_for_me" ? (
            <div>
              <ul className="list-group">
                <li className=" d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div>
                      <Link
                        to="/dashboard"
                        id={
                          activeLink == "dashboard"
                            ? "sidebar-active-item"
                            : null
                        }
                        className="sidebar-submenuitem"
                        style={{ paddingLeft: "70px" }}
                      >
                        <FlakyIcon
                          className="sidebar-sub-menu-icon"
                          style={{
                            fontSize: "40px",
                            marginLeft: "-9px",
                            color: "#ffffffad",
                          }}
                        />
                        <span style={{ marginTop: "12px", fontSize: "13px" }}>
                          {isAdmin === "true"
                            ? "Approval Dashboard"
                            : "Request Dashboard"}
                        </span>
                      </Link>
                    </div>
                    <div style={{ paddingLeft: "65px" }}>
                      <img
                        src={images.forem_sb}
                        className="menu-img"
                        alt="Questions asked by me"
                      />
                      <span style={{ marginTop: "5px" }}>Forum</span>
                    </div>
                    <Link
                      to="/questions-asked-by-me"
                      id={
                        activeLink == "que_by_me" ? "sidebar-active-item" : null
                      }
                      className="sidebar-submenuitem"
                      style={{ paddingLeft: "110px" }}
                    >
                      <img
                        src={images.my_questions}
                        className="sub-menu-img"
                        alt="Questions asked by me"
                      />
                      <span style={{ marginTop: "5px" }}>My Questions</span>
                    </Link>
                    <Link
                      to="/questions-answered-by-me"
                      id={
                        activeLink == "que_ans_by_me"
                          ? "sidebar-active-item"
                          : null
                      }
                      className="sidebar-submenuitem"
                      style={{ paddingLeft: "110px" }}
                    >
                      <img
                        src={images.my_answers}
                        className="sub-menu-img"
                        alt="Questions answered by me"
                      />
                      <span style={{ marginTop: "5px" }}>My Answers</span>
                    </Link>
                  </div>
                </li>
                <li className=" d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div style={{ paddingLeft: "65px" }}>
                      <img
                        src={images.knowledge_sb}
                        className="menu-img"
                        alt="Questions asked by me"
                      />
                      <span style={{ marginTop: "5px" }}>Knowledge</span>
                    </div>

                    <Link
                      to="/knowledge-created-by-me"
                      id={
                        activeLink == "knowledge_by_me"
                          ? "sidebar-active-item"
                          : null
                      }
                      className="sidebar-submenuitem"
                      style={{ paddingLeft: "110px" }}
                    >
                      <img
                        src={images.my_knowledge}
                        className="sub-menu-img"
                        alt="Knowledge created by me"
                      />
                      <span style={{ marginTop: "5px" }}>My Knowledge </span>
                    </Link>
                    <Link
                      to="/questions-for-me"
                      id={
                        activeLink == "questions_for_me"
                          ? "sidebar-active-item"
                          : null
                      }
                      className="sidebar-submenuitem"
                      style={{ paddingLeft: "110px" }}
                    >
                      <img
                        src={images.my_questions}
                        className="sub-menu-img"
                        alt="Knowledge created by me"
                      />
                      <span style={{ marginTop: "5px" }}>
                        Questions for me{" "}
                      </span>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          ) : null}
          <Link
            to="/bookmarks"
            id={activeLink == "bookmarks" ? "sidebar-active-item" : null}
            className="sidebar-menuitem"
          >
            <img
              src={images.bookmarks_sb}
              className="menu-img-bookmark"
              alt="Bookmarks"
            />
            <span style={{ marginTop: "5px" }}>Bookmarks</span>
          </Link>
          <Link
            to="/usefull-links"
            id={activeLink == "usefull_links" ? "sidebar-active-item" : null}
            className="sidebar-menuitem"
          >
            <img
              src={images.usefullinks_sb}
              className="menu-img"
              alt="Usefull links"
            />
            <span style={{ marginTop: "5px" }}>Useful links</span>
          </Link>
          <Link
            to="/guidelines"
            id={activeLink == "guidelines" ? "sidebar-active-item" : null}
            className="sidebar-menuitem"
          >
            <img
              src={images.guidelines_sb}
              className="menu-img"
              alt="Guidelines"
            />
            <span style={{ marginTop: "5px" }}>Guidelines</span>
          </Link>

          <Link
            to="/eventgallery"
            id={activeLink == "eventgallery" ? "sidebar-active-item" : null}
            className="sidebar-menuitem"
          >
            <img
              src={images.gallery_sb}
              className="menu-img"
              alt="EventGallery"
            />
            <span style={{ marginTop: "5px" }}>Events Gallery</span>
          </Link>
          <div
            onClick={() => setShowApplications(!showApplications)}
            style={{ cursor: "pointer" }}
            className="sidebar-menuitem"
          >
            <img
              src={images.dashboard_sb}
              className="menu-img"
              alt="Questions asked by me"
            />
            <span style={{ marginTop: "5px" }}>Applications </span>
            <img src={images.down_arrow} className="toggle-dashboard" />
          </div>
          {showApplications ? (
            <div>
              <ul className="list-group">
                <li className=" d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    {applicationsUrl && applicationsUrl.length > 0
                      ? applicationsUrl.map((apu, index) =>
                          apu.isActive ? (
                            <a
                              style={{ paddingLeft: "65px" }}
                              className="sidebar-submenuitem"
                              href={`${apu.url}/login?CK=${ck}&SC=mk`}
                              target="_blank"
                              rel="noreferrer"
                              key={index}
                            >
                              <LinkIcon style={{ marginRight: "0.5rem" }} />
                              <span style={{ marginTop: "5px" }}>
                                {apu.name}
                              </span>
                            </a>
                          ) : null
                        )
                      : null}
                  </div>
                </li>
              </ul>
            </div>
          ) : null}
          {isAdmin === "true" && (
            <div
              onClick={() => setShowReport(!showReport)}
              style={{ cursor: "pointer" }}
              className="sidebar-menuitem"
            >
              <img
                src={images.dashboard_sb}
                className="menu-img"
                alt="Report"
              />
              <span style={{ marginTop: "5px" }}>Reports</span>
              <img src={images.down_arrow} className="toggle-dashboard" />
            </div>
          )}
          {showReport ? (
            <div>
              <ul className="list-group">
                <li className=" d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <Link
                      to="/report"
                      id={activeLink == "Report" ? "sidebar-active-item" : null}
                      className="sidebar-submenuitem"
                      style={{ paddingLeft: "70px" }}
                    >
                      <CircleIcon className="sidebar-sub-menu-icon" />
                      <span style={{ marginTop: "5px" }}>
                        MKisan Feed Report
                      </span>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          ) : null}
          {/* <a
          className="sidebar-menuitem"
          href={`http://localhost:3002/login?CK=${ck}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={images.gallery_sb}
            className="menu-img"
            alt="EventGallery"
          />
          <span style={{ marginTop: "5px" }}>KMI</span>
        </a> */}
          {/* <Link
          to="/analytics"
          id={activeLink == "urls" ? "sidebar-active-item" : null}
          className="sidebar-menuitem"
        >
          <img
            src={images.guidelines_sb}
            className="menu-img"
            alt="Analytics"
          />
          <span style={{ marginTop: "5px" }}>Analytics</span>
        </Link> */}
        </div>
        <div className="sidebar-footer justify-space-between">
          <img
            src={images.logout}
            alt="Logout"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Logout"
            className="menu-img"
            onClick={() => setModal(true)}
          />

          {showModal ? (
            // <Modal
            //   open={showModal}
            //   onClose={() => setModal(false)}
            //   className="modal-dialog modal-dialog-centered"
            // >
            //   <div className="modal-content logout-modal">
            //     <div className="modal-body">
            //       Are you sure you want to logout?
            //     </div>
            //     <div className="display-row justify-space-evenly">
            //       <button
            //         className="btn btn-danger "
            //         type="button"
            //         onClick={() => setModal(false)}
            //       >
            //         Cancel
            //       </button>
            //       {/* <Link to="/"> */}
            //       <button
            //         className="btn btn-success "
            //         type="button"
            //         onClick={logout}
            //       >
            //         Logout
            //       </button>
            //       {/* </Link> */}
            //     </div>
            //   </div>
            // </Modal>
            <LogoutDialogueBox
              open={showModal}
              close={() => setModal(false)}
              cancel={() => setModal(false)}
              logout={logout}
            />
          ) : null}

          {/* <img
            src={images.settings}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Settings"
            alt="Settings"
            className="menu-img"
          /> */}
        </div>
      </div>
    </nav>
  );
}

export default Sidebar;

Sidebar.propTypes = {
  activeLink: PropTypes.string,
  history: PropTypes.object,
  renderAgain: PropTypes.bool,
};
